import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import {useRouter} from '../../providers/Router/RouterProvider';
import { CHARGER_IMAGE } from '../../assets/images';

import './styles.css';
import { useScanningAnimation } from './useScanningAnimation';

export const ScannerScreen = () => {
  const { navigate } = useRouter();

  const { zoomLevel, scanComplete, offset } = useScanningAnimation();

  useEffect(() => {
    if (scanComplete) {
      const timeout = setTimeout(() => {
        navigate('rateplan');
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [navigate, scanComplete]);

  return (
    <div className="ScannerScreen h-screen w-full bg-black overflow-hidden relative">
      <motion.div
        className="absolute"
        style={{
          minHeight: '100%',
          minWidth: '100%'
        }}
        animate={{
          scale: zoomLevel,
          x: offset.x,
          y: offset.y,
        }}
        transition={{ duration: 0.2, ease: "linear" }}
      >
        <img
          src={CHARGER_IMAGE}
          alt="Charger"
          className="object-cover"
          style={{
            minHeight: '100%',
            minWidth: '100%'
          }}
        />
      </motion.div>

      <div className="absolute inset-0 flex flex-col items-center justify-between p-4">
        <div className="w-full bg-gray-800 text-white p-2 rounded-lg">
          <p className="text-center">Scan QR Code</p>
        </div>

        <div className="w-64 h-64 border-2 border-white relative">
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-white" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-white" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-white" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-white" />
        </div>

        <div className="w-full bg-gray-800 text-white p-2 rounded-lg">
          <p className="text-center">Scan the QR code on the outlet to start charging</p>
        </div>
      </div>

      {scanComplete && (
        <motion.div
          className="absolute inset-0 bg-white"
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 0.8, 0] }}
          transition={{ duration: 1 }}
        />
      )}
    </div>
  );
}